import Chip from '@components/Chip';
import styled from '@emotion/styled';
import { GiftBoxType } from '@models/gift';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
    type: GiftBoxType;
    setType: Dispatch<SetStateAction<GiftBoxType>>;
}

function GiftBoxChips({ type, setType }:Props) {
    const { t } = useTranslation('gift');
    return (
        <Container>
            <Chip.Container variant='outline'>
                <Chip isSelected={type === 'RECEIVED'}
                    onClick={() => setType(GiftBoxType.RECEIVED)}>
                    {t('giftBox.received')}
                </Chip>
                <Chip isSelected={type === 'SENT'}
                    onClick={() => setType(GiftBoxType.SENT)}>
                    {t('giftBox.sent')}
                </Chip>
            </Chip.Container>
        </Container>
    );
}

const Container = styled.div`
    padding: 16px 20px
`;

export default GiftBoxChips;
